import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  title: {
    height: '72px',
    marginBottom: '0.75rem'
  },
  subtitle: {
    height: '30px',
    marginBottom: '0.75rem'
  },
  input: {
    height: '48px',
    marginBottom: '1rem'
  },
  row: {
    marginTop: '20%'
  },
  rowContent: {
    marginTop: '10%'
  }
};

const SkeletonNewsletter = (props) => {
  const [className, style] = useStyles(props);
  const { title, subtitle, input, row, rowContent } = styles;

  const newStyle = {
    backgroundColor: '#777777',
    ...style
  };

  return (
    <Box className={`${className} fr-skeleton`} style={newStyle} dataTestId="skeletonNewsletter">
      <Box
        display="flex"
        className="fr-container"
        flexDirection={props?.isMobile ? 'column' : 'row'}
      >
        <Col xs={props?.isMobile ? '12' : '4'}>
          <Row gutters style={row}>
            <Col xs="12">
              <Box className="fr-skeleton-element" style={title} />
            </Col>
            <Col xs="12">
              <Box className="fr-skeleton-element" style={subtitle} />
            </Col>
          </Row>
        </Col>
        <Col xs={props?.isMobile ? '12' : '8'}>
          <Row gutters style={rowContent}>
            <Col xs={props?.isMobile ? '6' : '4'}>
              <Box className="fr-skeleton-element" style={input} />
            </Col>
            <Col xs={props?.isMobile ? '6' : '4'}>
              <Box className="fr-skeleton-element" style={input} />
            </Col>
            <Col xs={props?.isMobile ? '12' : '4'}>
              <Box className="fr-skeleton-element" style={input} />
            </Col>
            <Col xs={props?.isMobile ? '12' : '8'}>
              <Box className="fr-skeleton-element" style={input} />
            </Col>
          </Row>
        </Col>
      </Box>
    </Box>
  );
};

SkeletonNewsletter.componentName = 'SkeletonNewsletter';

export default SkeletonNewsletter;
